(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-cta-card"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.blog-cta-card').on('click', '.section-card', function (e) {
      if ($(this).find('.section-buttons a').length < 2) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.assign($(this).find('.btn-link').attr('href'));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  jQuery(document).ready(function () {

    const maxDiscountedProduct = 6867308052568;
    const maxFilterProduct = 4692162969688;

    const plusDiscountedProduct = 78402657950000000000000;
    const essentialDiscountedProduct = 6855283703896;
    const plusEssentialFilterProduct = 6742272082008;

    console.table(window.Cart.items);
  
    if (window.Cart && window.Cart.items) {
      // Check if cart has a max filter bundle
      const cartHasMaxBundle = window.Cart.items.some(function (item) {
        return item.product_id === maxDiscountedProduct;
      });

      if (cartHasMaxBundle) {
        const filterCartItem = document.querySelector('[data-product_id="' + maxFilterProduct + '"]');
        if (filterCartItem) {
          // Disable removing of purifier
          filterCartItem.querySelector('.cart-item__remove').remove();
          filterCartItem.querySelector('.cart__quantity').style.visibility = 'hidden';
        } else {
          // If no filter product exist on cart, REMOVE Max Bundle Product $299
          document.querySelector('[data-product_id="' + maxDiscountedProduct + '"] .cart-item__remove').click();
        }
      }

      const cartHasPlusBundle = window.Cart.items.some(function (item) {
        return item.product_id === plusDiscountedProduct;
      });

      const cartHasEssentialBundle = window.Cart.items.some(function (item) {
        return item.product_id === essentialDiscountedProduct;
      });

      if (cartHasPlusBundle || cartHasEssentialBundle) {
        const filterCartItem = document.querySelectorAll('[data-product_id="' + plusEssentialFilterProduct + '"]');
        if (filterCartItem.length > 0) {
          // Disable removing of purifier
          filterCartItem.forEach(function (el) {
            el.querySelector('.cart-item__remove').remove();
            el.querySelector('.cart__quantity').style.visibility = 'hidden';
          });
        } else {
          // If no filter product exist on cart, REMOVE plus/essential Bundle Product $299
          document.querySelector('[data-product_id="' + plusDiscountedProduct + '"] .cart-item__remove').click();
          document.querySelector('[data-product_id="' + essentialDiscountedProduct + '"] .cart-item__remove').click();
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-about-sentry"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-links').on('click', '.section-link', function () {
      const id = $(this).attr('data-href');
      if (id.includes('slide')) {
        const slider = document.querySelector('.section-features-slider-right .section-slider');
        slider.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        const slide = parseInt(id.replace('#slide-', '') || 1) - 1;
        setTimeout(function () {
          $('.section-features-slider-right .section-slider').slick('slickGoTo', slide);
        }, 500);
      } else {
        const section = $(id).get(0);
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    });

    // Query all elements with the class 'section-link-label'
    const labels = document.querySelectorAll('.section-link-label');
    let maxHeight = 0;

    for (let i = 0; i < labels.length; i++) {
      const label = labels[i];
      const height = label.clientHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    }
    for (let j = 0; j < labels.length; j++) {
      labels[j].style.height = maxHeight + 'px';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-book-modal"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('body').on('click', '[data-open="modal"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal($(this).attr('data-modal'));
    });
    $('body').on('click', '[data-dismiss="modal"]', function (e) {
      dismissModal(e);
    });

    let showModalTimeout = null;
    let dismissModalTimeout = null;
    const showModal = function (id) {
      if (showModalTimeout) {
        clearTimeout(showModalTimeout);
      }

      const modal = $(id);

      console.log(modal);

      if (modal.length) {
        modal.css('display', 'block');
        $('body').addClass('modal-open');

        showModalTimeout = setTimeout(function () {
          modal.addClass('modal--active');

          modal[0].scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
          });
        }, 25);
      }
    };

    const dismissModal = function (e) {
      if (!event.target.className.includes('backdrop') && !event.target.className.includes('close')) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      const modal = $($(e.target).attr('data-modal'));
      console.log(modal);

      if (dismissModalTimeout) {
        clearTimeout(dismissModalTimeout);
      }

      modal.removeClass('modal--active');
      $('body').removeClass('modal-open');

      dismissModalTimeout = setTimeout(() => {
        modal.css('display', 'none');
      }, 200);
    };

    $('body').on('click', '[href="#book-a-demo"]', function (event) {
      event.preventDefault();
      showModal('#book-modal');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-card-cta"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('.section-card-cta').on('click', '.section-card', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const btn = $(this).find('.btn-link').first()
      if(btn.length){
        window.location.assign(btn.attr('href'));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-card-link"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-card-link').on('click', '.section-card', function (e) {
      window.open($(this).find('a').first().attr('href'),'_blank');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-card-modal"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    $('body').on('click', '[data-open="modal"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal($(this).attr('data-modal'));
    });
    $('body').on('click', '[data-dismiss="modal"]', function (e) {
      dismissModal(e);
    });

    let showModalTimeout = null;
    let dismissModalTimeout = null;
    const showModal = function (id) {
      if (showModalTimeout) {
        clearTimeout(showModalTimeout);
      }

      const modal = $(id);

      console.log(modal);

      if (modal.length) {
        $('body').addClass('modal-open');
        modal.css('display', 'block');
        showModalTimeout = setTimeout(function () {
          modal.addClass('modal--active');
          modal[0].scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
          });
        }, 25);
      }
    };

    const dismissModal = function (e) {
      if (!event.target.className.includes('backdrop') && !event.target.className.includes('close')) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      const modal = $($(e.target).attr('data-modal'));

      if (dismissModalTimeout) {
        clearTimeout(dismissModalTimeout);
      }

      $('body').removeClass('modal-open');

      if (modal) {
        modal.removeClass('modal--active');
        dismissModalTimeout = setTimeout(() => {
          modal.css('display', 'none');
        }, 200);
      }
    };

    $('body').on('click', '[href="#air-id"]', function (event) {
      event.preventDefault();
      showModal('#card-modal');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-card-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var sectionCardRow = document.querySelector('.section-card-row');

    sectionCardRow.addEventListener('click', function (e) {
      var target = e.target;

      while (target !== sectionCardRow) {
        if (target.classList.contains('section-card')) {
          console.log(e);
          e.preventDefault();
          e.stopImmediatePropagation();

          var link = target.querySelector('a').getAttribute('href');
          window.open(link, '_blank');

          break;
        }

        target = target.parentNode;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-case-studies"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $(function () {
      const startVideoSlider = function () {
        $('#sentry-case-studies .case-list').slick({
          arrows: true,
          autoplay: false,
          infinite: false,
          variableWidth: true,
          adaptiveHeight: false,
          appendArrows: '#sentry-case-studies .section-arrows',
          prevArrow: '<button type="button" class="slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-next"></button>',
          responsive: [
            {
              breakpoint: 1497,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      };

      startVideoSlider();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-faq"]) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-faq').on('click', '.section-title', function () {
      $(this).closest('.section-faq').toggleClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-feature-evidence"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-feature-evidence').on('click','.zoom-icon',function(){
      $('img[data-enlargeable]').trigger('click');
    })
    
    $('img[data-enlargeable]').addClass('img-enlargeable').click(function() {
    var src = $(this).attr('src');
    var modal;

    function removeModal() {
      modal.remove();
      $('body').off('keyup.modal-close');
    }
    modal = $('<div>').css({
      background: 'RGBA(0,0,0,.5) url(' + src + ') no-repeat center',
      backgroundPosition: 'center',
      backgroundSize: '70%',
      width: '100%',
      height: '100%',
      position: 'fixed',
      zIndex: '10000',
      top: '0',
      left: '0',
      cursor: 'zoom-out',
    }).click(function() {
      removeModal();
    }).appendTo('body');
    //handling ESC
    $('body').on('keyup.modal-close', function(e) {
      if (e.key === 'Escape') {
        removeModal();
      }
    });
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-features-slider-right"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function () {
    $('.section-features-slider-right .section-slider').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        adaptiveHeight: false,
        appendDots: '.section-features-slider-right .slider-dots',
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-features-slider"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-features-slider .section-slider')
      .slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        adaptiveHeight: false,
        appendDots: '.section-features-slider .slider-dots',
      })
      .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.section-tabs .slide-tab').eq(nextSlide).addClass('active').siblings().removeClass('active');
      });

    $('.section-tabs .slide-tab').first().addClass('active');

    $('.section-tabs .slide-tab').click(function () {
      $('.section-features-slider .section-slider').slick('slickGoTo', parseInt($(this).data('index')));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-form-hubspot-plus"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    const updateSchedForm = function () {
      const schedForm = $('#schedule-demo').first();
      if (schedForm) {
        if (window.innerWidth < 1045) {
          $('#schedule-demo .section-background.hide-desktop').css(
            'height',
            $('#schedule-demo .section-content').height() + 105 + 'px'
          );
        }
      }
    };

    updateSchedForm();
    $(window).on('resize', function () {
      updateSchedForm();
    });

    const playerEl = document.getElementById('giveaway-video');

    if (playerEl) {
      // Load the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/player_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Replace the 'ytplayer' element with an <iframe> and
      // YouTube player after the API code downloads.
      var player;

      window.onYouTubePlayerAPIReady = function () {
        player = new YT.Player('giveaway-video', {
          videoId: 'C8YdIgu6Kf4',
          playerVars: {
            rel: 0,
            autoplay: 1,
          },
          events: {
            onReady: function (event) {
              // Use a timeout to play the video after a short delay
              setTimeout(function () {
                event.target.playVideo();
              }, 500); // Delay in milliseconds (adjust as needed)
            },
          },
        });

        player.playVideo();
      };
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero-plus"]) return;
  try {
    
  jQuery(document).ready(function () {
    const playerEl = document.getElementById('ytplayer');
    if (playerEl) {
      // Load the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Replace the 'ytplayer' element with an <iframe> and
      // YouTube player after the API code downloads.
      var player;

      function unhideVideo() {
        document.querySelector('.video-container').classList.add('unhide');
        setTimeout(() => {
          player.playVideoAt(0);
        }, 500);
      }

      window.onYouTubePlayerAPIReady = function () {
        player = new YT.Player('ytplayer', {
          videoId: 'C8YdIgu6Kf4',
          playerVars: {
            rel: 0,
            autoplay: 0,
          },
        });
      };
    }

    $('.section-hero').on('click', '[href^="#toggle-nav"]', function (event) {
      event.preventDefault();
      $('.section-nav-links').toggleClass('open');
      $('.btn-nav-toggle').toggleClass('open');
    });
    $('.section-hero').on('click', '[href^="#buy"]', function (event) {
      event.preventDefault();
      const section = $('.section-sentry-plan').get(0);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });

    $('.section-hero').on('click', '[href^="#about"]', function (event) {
      event.preventDefault();
      const section = $('.section-about-sentry').get(0);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });

    $('.section-hero').on('click', '[href^="#get-started"]', function (event) {
      event.preventDefault();
      const section = $('.section-form-hubspot').get(0);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });

    $('.section-hero').on('click', '[href^="#watch"]', function (event) {
      event.preventDefault();
      unhideVideo();
      const section = $('.section-hero-plus .video-container').get(0);
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    const stickyElem = $('.section-sticky-nav');
    if (stickyElem.length > 0) {
      const stickyPos = stickyElem[0].getBoundingClientRect().top + document.documentElement.scrollTop;

      $(window).on('scroll', function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > stickyPos) {
          stickyElem.addClass('sticky');
        } else {
          stickyElem.removeClass('sticky');
        }
      });
    }

    const elCounter = document.querySelector('.section-incidents-count span');
    if (elCounter) {
      const counterUp = window.counterUp.default;

      const callback = (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting && !el.classList.contains('is-visible')) {
            counterUp(el, {
              duration: 2000,
              delay: 30,
            });
            el.classList.add('is-visible');
          }
        });
      };

      const IO = new IntersectionObserver(callback, { threshold: 1 });

      IO.observe(elCounter);
    }

    if (window.location.search.includes('giveaway')) {
      Swal.fire({
        title: 'Success!',
        html: 'Thank you for entering for a chance to win a one year subscription to WYND Sentry! You will be notified via email if you win the giveaway. <br/><br/> In the meantime, please enjoy $20 off your WYND Sentry order with promo code “WIN20” at checkout.',
        icon: 'success',
        confirmButtonText: 'Continue',
        confirmButtonColor: '#37c9ce',
      });
    }

    const trustedPartners = $('.section-partners.trusted .section-logos');

    if (trustedPartners.length) {
      if(trustedPartners.hasClass('more-than-four')){
        trustedPartners.slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 7,
            },
          },
          {
            breakpoint: 1046,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      }else{
        trustedPartners.slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        responsive: [
          {
            breakpoint: 1046,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      }
      
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero-slider"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-hero-slider .section-slides').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      adaptiveHeight: true,
      appendDots: '.section-footer .section-content',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-hero"]) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-hero').on('click', '[href^="#toggle-nav"]', function (event) {
      event.preventDefault();
      $('.section-nav-links').toggleClass('open');
      $('.btn-nav-toggle').toggleClass('open');
    });

    const stickyElem = $('.section-sticky-nav');
    const stickyPos = stickyElem[0].getBoundingClientRect().top + document.documentElement.scrollTop;

    $(window).on('scroll', function (event) {
      var scroll = $(window).scrollTop();
      if (scroll > stickyPos) {
        stickyElem.addClass('sticky');
      } else {
        stickyElem.removeClass('sticky');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-information-slider"]) return;
  try {
    
jQuery(document).ready(function () {
    $('.section-information-slider .section-slider').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        adaptiveHeight: false,
        appendDots: '.section-information-slider .slider-dots',
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-partners-slider"]) return;
  try {
    
  jQuery(document).ready(function ($) {
    $(function () {
      $('#sentry-partners-slider .section-slider-list').on('click', '.slider-item', function () {
        const url = $(this).attr('href').trim();
        if (url != '') {
          window.location.assign(url);
        }
      });

      $('#sentry-partners-slider .section-slider-list').slick({
        arrows: true,
        autoplay: false,
        infinite: false,
        variableWidth: true,
        adaptiveHeight: false,
        appendArrows: '#sentry-partners-slider .section-slider-arrows',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-reviews-sentry"]) return;
  try {
    
  jQuery(document).ready(function ($) {
    const params = new URLSearchParams('');

    params.set('include', 'product,customer');
    params.set('filter[product_ids]', ['3632376']);
    params.set('page[size]', ['100']);

    $(function () {
      const startVideoSlider = function () {
        $('#sentry-reviews-plus .video-list').slick({
          arrows: true,
          autoplay: false,
          infinite: false,
          variableWidth: true,
          adaptiveHeight: false,
          appendArrows: '#sentry-reviews-plus .video-arrows',
          prevArrow: '<button type="button" class="slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-next"></button>',
        });
      };
      const addReviews = function (reviews) {
        review_visible = 0;
        review_count = reviews.length;

        const except = [2340721, 2340700, 2340692, 2340676];
        reviews.forEach((review) => {
          if (except.includes(review.id)) return;
          const fullname = [review.customer.first_name, review.customer.last_name].join(' ');
          const scorePercent = function (score, total = 5) {
            return (score / total) * 100 + '%';
          };
          const review_item = `
                   <div class="review-item">
                       <div class="review-content">
                           <div class="review-star" data-rating="${review.rating}">
                               <div class="fill" style=" width: ${scorePercent(review.rating)} "></div>
                           </div>
                           <div class="review-title">${review.title}</div>
                           <div class="review-body">${review.body}
                           </div>
                       </div>
                       <div class="review-overview">
                           <div class="review-author">${fullname}</div>
                           <div class="review-verified">Verified Buyer</div>
                           <div class="review-recommend">I recommend this product</div>
                       </div>
                   </div>`;

          $('#sentry-reviews-plus .section-reviews-list').append(review_item);
        });

        startSlider();
      };

      let review_count = 0;
      let review_visible = 0;

      const startSlider = function () {
        $('#sentry-reviews-plus .section-reviews-list').slick({
          arrows: true,
          autoplay: false,
          infinite: false,
          variableWidth: true,
          adaptiveHeight: false,
          appendArrows: '#sentry-reviews-plus .section-reviews-arrows',
          prevArrow: '<button type="button" class="slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-next"></button>',
        });
      };

      startVideoSlider();

      $('#sentry-reviews-plus').on('click', '.video-thumbnail:not(.show)', function () {

        $('#sentry-reviews-plus').find('video').each(function(){
          $(this)[0].pause();
          $(this).closest('.show').removeClass('show');
        });
        
        $(this).addClass('show');
        const video = $(this).find('video');

        if(video){
          video[0].currentTime = 0;
          video[0].play();
          $('#sentry-reviews-plus .video-list').slick('slickPause');
        }
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-sentry-calculator-form-family"]) return;
  try {
    
  jQuery(document).ready(function () {
    $('#calculator form').submit(function (event) {
      event.preventDefault();

      var form = this;

      // User Inputs
      var number_of_hotel_rooms = parseInt($(this).find('[name="number_of_hotel_rooms"]').first().val() || 1);
      var smoking_incidents_per_month = parseInt(
        $(this).find('[name="smoking_incidents_per_month"]').first().val() || 0
      );
      var smoking_fee = parseInt($(this).find('[name="smoking_fee"]').first().val() || 0);

      // Personal Info
      var email = $(this).find('[name="email"]').first().val() || '';
      var firstname = $(this).find('[name="firstname"]').first().val() || '';
      var lastname = $(this).find('[name="lastname"]').first().val() || '';
      var company = $(this).find('[name="company"]').first().val() || '';

      // Base
      var monthly_cost_of_sentry = 9;
      var total_devices_per_unit = 1;
      var total_devices = total_devices_per_unit * number_of_hotel_rooms;
      var ave_monthly_rent = 787;

      // Costs Avoidance
      var percent_of_units_smoking = 29.7 / 100;
      var number_of_units_smoking = number_of_hotel_rooms * percent_of_units_smoking;
      var labor_cost_per_hour = 40;
      var labor_cost_per_incident = 2 * labor_cost_per_hour;

      var addtl_renovation_costs_of_smoker_occupied_units = 1674;
      var average_occupier_turnover_rate = 9 / 100;
      var ave_addtl_renovation_costs_per_building_per_year =
        addtl_renovation_costs_of_smoker_occupied_units * number_of_units_smoking * average_occupier_turnover_rate;

      var reduced_fire_risk = 32700000 / 1159913;
      var total_fire_risk_reduction = reduced_fire_risk * number_of_hotel_rooms;
      var monthly_risk_of_fire_damage =
        (((total_devices * number_of_hotel_rooms * 12) / 0.058) * (0.0001 * smoking_incidents_per_month)) / 12;

      var reduced_turnover_cost = 100;
      var total_reduced_turnover_cost = reduced_turnover_cost * number_of_hotel_rooms;

      var reduced_insurance_premium = 10 / 100;
      var ave_pc_insurance = 7500 * 10;
      var ave_reduced_insurance_premium = ave_pc_insurance * reduced_insurance_premium;
      var health_risks_to_tenants = 100000 / 12;
      var monthly_inspection_costs = smoking_incidents_per_month * labor_cost_per_incident;

      var rent_premium = 4 / 100;
      var ave_rent_premium = number_of_hotel_rooms * ave_monthly_rent * rent_premium;

      var value_of_each_incidence = 40 * 2 * smoking_incidents_per_month;
      var value_of_being_smoke_free =
        0.05 *
        smoking_incidents_per_month *
        (labor_cost_per_incident + health_risks_to_tenants * 0.05 + monthly_risk_of_fire_damage * 0.05);

      var roi_reduced_addtl_renovation_costs = ave_addtl_renovation_costs_per_building_per_year;
      var roi_reduced_fire_risk = total_fire_risk_reduction;
      var roi_reduced_turnover_cost = total_reduced_turnover_cost;
      var roi_healthcare_cost_for_employees = health_risks_to_tenants;
      var roi_reduced_inspection_costs = monthly_inspection_costs;
      var roi_other_cost_reductions = 0;
      var roi_rent_premium = ave_rent_premium;
      var roi_total_annual_revenue =
        roi_reduced_addtl_renovation_costs +
        roi_reduced_fire_risk +
        roi_reduced_turnover_cost +
        roi_healthcare_cost_for_employees +
        roi_reduced_inspection_costs +
        roi_other_cost_reductions +
        roi_rent_premium;

      var sentry_annual_cost = monthly_cost_of_sentry * 12 * total_devices;
      var calculated_roi = roi_total_annual_revenue / sentry_annual_cost;

      $(this).find('[name="calculated_roi"]').first().val(calculated_roi);
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });
      $.ajax({
        type: 'POST',
        url: 'https://hooks.zapier.com/hooks/catch/12923772/3cq48n9/',
        data: JSON.stringify({
          email: email,
          firstname: firstname,
          lastname: lastname,
          company: company,
          number_of_hotel_rooms: number_of_hotel_rooms,
          smoking_incidents_per_month: smoking_incidents_per_month,
          smoking_fee: smoking_fee,

          roi_reduced_addtl_renovation_costs: roi_reduced_addtl_renovation_costs,
          roi_reduced_fire_risk: roi_reduced_fire_risk,
          roi_reduced_turnover_cost: roi_reduced_turnover_cost,
          roi_healthcare_cost_for_employees: roi_healthcare_cost_for_employees,
          roi_reduced_inspection_costs: roi_reduced_inspection_costs,
          roi_other_cost_reductions: roi_other_cost_reductions,
          roi_rent_premium: roi_rent_premium,

          roi_total_annual_revenue: roi_total_annual_revenue,
          sentry_annual_cost: sentry_annual_cost,
          calculated_roi: calculated_roi,
        }),
        success: function (data) {
          $(form)
            .find('.field-result-table')
            .html(
              `<div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label style="font-size:1rem">Return on Investment</label></div>
                <div class="field-item"><div class="field-result"></div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Reduced Additional Renovation Costs from Cleaning up Smoking Units</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_reduced_addtl_renovation_costs
                )}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Reduced Fire Risk</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_reduced_fire_risk
                )}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Reduced Turnover Cost (of Non-Smoking Tenants)</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_reduced_turnover_cost
                )}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Reduced Healthcare Costs for Employees</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_healthcare_cost_for_employees
                )}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Reduced Inspection Costs</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_reduced_inspection_costs
                )}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Other Cost Reductions</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_other_cost_reductions
                )}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label style="font-size:1rem">Rent Premium</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_rent_premium
                )}</div></div>
              </div>
              <div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label style="font-size:1rem">Total Annual Value</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  roi_total_annual_revenue
                )}</div></div>
              </div>
              <div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label style="font-size:1rem">Sentry Annual Cost</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${formatter.format(
                  sentry_annual_cost
                )}</div></div>
              </div>
              <div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label style="font-size:1rem">Return on Investment</label></div>
                <div class="field-item"><div style="font-size:1rem" class="field-result-item">${calculated_roi.toFixed(
                  2
                )}x</div></div>
              </div>
              `
            );

          $(form).find('.field-row:not(.field-results-item)').hide();
        },
        error: function (err) {
          console.error(err);
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-sentry-calculator-form"]) return;
  try {
    
  jQuery(document).ready(function () {
    $('#calculator form').submit(function (event) {
      event.preventDefault();

      var form = this;

      var number_of_hotel_rooms = $(this).find('[name="number_of_hotel_rooms"]').first().val() || 1;
      var cost_of_smoking = $(this).find('[name="cost_of_smoking_incident"]').first().val() || 0;
      var smoking_incidents_per_month = $(this).find('[name="smoking_incidents_per_month"]').first().val() || 0;
      var fee_collection_before = ($(this).find('[name="smoking_fee_collection_rate"]').first().val() || 0) / 100;

      var smoking_fee = $(this).find('[name="smoking_fee"]').first().val() || 0;

      var average_room_rate = $(this).find('[name="average_room_rate"]').first().val() || 0;
      var smoking_fee = $(this).find('[name="smoking_fee"]').first().val() || 0;
      var email = $(this).find('[name="email"]').first().val() || '';
      var firstname = $(this).find('[name="firstname"]').first().val() || '';
      var lastname = $(this).find('[name="lastname"]').first().val() || '';
      var company = $(this).find('[name="company"]').first().val() || '';

      var fee_collection_after = 0.99;
      var monthly_cost_of_sentry = number_of_hotel_rooms * 8;

      var cost_of_smoking_per_month = cost_of_smoking * smoking_incidents_per_month;
      var addtl_revenue_collections =
        smoking_fee * smoking_incidents_per_month * (fee_collection_after - fee_collection_before);

      var total_per_month = cost_of_smoking_per_month + addtl_revenue_collections;

      var calculated_roi = total_per_month / monthly_cost_of_sentry;

      $(this).find('[name="calculated_roi"]').first().val(calculated_roi);

      $.ajax({
        type: 'POST',
        url: 'https://hooks.zapier.com/hooks/catch/12923772/38inwsm/',
        data: JSON.stringify({
          number_of_hotel_rooms: number_of_hotel_rooms,
          cost_of_smoking: cost_of_smoking,
          smoking_incidents_per_month: smoking_incidents_per_month,
          fee_collection_before: fee_collection_before * 100,
          smoking_fee: smoking_fee,
          average_room_rate: average_room_rate,
          smoking_fee: smoking_fee,
          email: email,
          company: company,
          firstname: firstname,
          lastname: lastname,
          calculated_roi: calculated_roi,
        }),
        success: function (data) {
          $(form)
            .find('.field-result-table')
            .html(
              `<div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label>Sentry Customer Savings</label></div>
                <div class="field-item"><div class="field-result"></div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Number of hotel rooms</label></div>
                <div class="field-item"><div class="field-result-item">${number_of_hotel_rooms}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Average room rate</label></div>
                <div class="field-item"><div class="field-result-item">$${average_room_rate}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Cost of smoking incident</label></div>
                <div class="field-item"><div class="field-result-item">$${cost_of_smoking}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Smoking fee</label></div>
                <div class="field-item"><div class="field-result-item">$${smoking_fee}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Fee collectionrate, before</label></div>
                <div class="field-item"><div class="field-result-item">${(fee_collection_before * 100).toFixed(
                  0
                )}%</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Fee collectionrate, after</label></div>
                <div class="field-item"><div class="field-result-item">99%</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Smoking incidents per month</label></div>
                <div class="field-item"><div class="field-result-item">${smoking_incidents_per_month}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Cost of smoking per month</label></div>
                <div class="field-item"><div class="field-result-item">$${cost_of_smoking_per_month}</div></div>
              </div>
              <div class="field-row field-results-item">
                <div class="field-item"><label>Additional revenue of collections</label></div>
                <div class="field-item"><div class="field-result-item">$${addtl_revenue_collections}</div></div>
              </div>
              <div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label>Total value per month</label></div>
                <div class="field-item"><div class="field-result-item">$${total_per_month}</div></div>
              </div>
              <div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label>(/) Monthly cost of sentry</label></div>
                <div class="field-item"><div class="field-result-item">$${monthly_cost_of_sentry}</div></div>
              </div>
              <div class="field-row field-results-item field-results-bold">
                <div class="field-item"><label>Your Calculated ROI</label></div>
                <div class="field-item"><div class="field-result">${calculated_roi.toFixed(2)}x</div></div>
              </div>
              `
            );

          $(form).find('.field-row:not(.field-results-item)').hide();
        },
        error: function (err) {
          console.error(err);
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-sentry-plan-annual"] && !Shopify.designMode) return;
  try {
    
  const planAnnual = {
    currency: 'USD',
    value: 180,
    valueAnnual: 180,
    items: [
      {
        item_id: 'prod_M14yp4ml94VL1P',
        item_name: 'WYND Sentry Subscription',
        item_category: 'annual',
        currency: 'USD',
        discount: 48,
        item_brand: 'Wynd',
        price: 180,
        quantity: 1,
      },
    ],
  };

  const planMonthly = {
    currency: 'USD',
    value: 19,
    valueAnnual: 228,
    items: [
      {
        item_id: 'prod_M14yp4ml94VL1P',
        item_name: 'WYND Sentry Subscription',
        item_category: 'monthly',
        currency: 'USD',
        discount: 0,
        item_brand: 'Wynd',
        price: 19,
        quantity: 1,
      },
    ],
  };

  // Event on Page load
  document.addEventListener('DOMContentLoaded', function (event) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'sentry_view_item',
      ecommerce: planAnnual,
    });

    if (typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_view_item', {
      currency: 'USD',
      value: planAnnual.value,
      contents: [
        { id: planAnnual.items[0].item_id, quantity: 1, valueAnnual: planAnnual.valueAnnual, value: planAnnual.value },
      ],
      content_ids: [planAnnual.items[0].item_id],
      content_name: planAnnual.items[0].item_name,
      content_type: 'product',
    });
  });

  // Event on Top right “Buy” button clicked
  document.querySelector('.section-hero-plus a.btn-buy').addEventListener('click', function (event) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'sentry_buy',
      ecommerce: planAnnual,
    });

    if (typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_buy', {
      currency: 'USD',
      value: planAnnual.value,
      contents: [
        { id: planAnnual.items[0].item_id, quantity: 1, valueAnnual: planAnnual.valueAnnual, value: planAnnual.value },
      ],
      content_ids: [planAnnual.items[0].item_id],
      content_name: planAnnual.items[0].item_name,
      content_type: 'product',
    });
  });

  // Event on Banner “ORDER NOW” button clicked
  document
    .querySelector('.section-hero-plus .section-hero-content a.btn-primary')
    .addEventListener('click', function (event) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'sentry_order_now',
        ecommerce: planAnnual,
      });

      if (typeof fbq === 'undefined') return;

      fbq('trackCustom', 'sentry_order_now', {
        currency: 'USD',
        value: planAnnual.value,
        contents: [
          {
            id: planAnnual.items[0].item_id,
            quantity: 1,
            valueAnnual: planAnnual.valueAnnual,
            value: planAnnual.value,
          },
        ],
        content_ids: [planAnnual.items[0].item_id],
        content_name: planAnnual.items[0].item_name,
        content_type: 'product',
      });
    });

  // Event on Banner “WATCH VIDEO” button clicked
  document
    .querySelector('.section-hero-plus .section-hero-content a.btn-watch')
    ?.addEventListener('click', function (event) {
      dataLayer.push({
        event: 'sentry_video_watch',
      });

      if (typeof fbq === 'undefined') return;

      fbq('trackCustom', 'sentry_video_watch');
    });

  // Event on airID section “Learn More” button clicked
  document.querySelector('.section-card-modal [data-open="modal"]').addEventListener('click', function (event) {
    dataLayer.push({
      event: 'sentry_airid_learn',
    });

    if (typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_airid_learn');
  });

  // Event on Case study section clicked
  document.querySelector('.section-card-link .section-card').addEventListener('click', function (event) {
    dataLayer.push({
      event: 'sentry_case_learn',
    });

    if (typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_case_learn');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-sentry-plan"] && !Shopify.designMode) return;
  try {
    
  const planAnnual = {
    currency: 'USD',
    value: 180,
    valueAnnual: 180,
    items: [
      {
        item_id: 'prod_M14yp4ml94VL1P',
        item_name: 'WYND Sentry Subscription',
        item_category: 'annual',
        currency: 'USD',
        discount: 48,
        item_brand: 'Wynd',
        price: 180,
        quantity: 1,
      },
    ],
  };

  const planMonthly = {
    currency: 'USD',
    value: 19,
    valueAnnual: 228,
    items: [
      {
        item_id: 'prod_M14yp4ml94VL1P',
        item_name: 'WYND Sentry Subscription',
        item_category: 'monthly',
        currency: 'USD',
        discount: 0,
        item_brand: 'Wynd',
        price: 19,
        quantity: 1,
      },
    ],
  };

  // Event on Page load
  document.addEventListener('DOMContentLoaded', function (event) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'sentry_view_item',
      ecommerce: planAnnual,
    });

    if(typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_view_item', {
      currency: 'USD',
      value: planAnnual.value,
      contents: [
        { id: planAnnual.items[0].item_id, quantity: 1, valueAnnual: planAnnual.valueAnnual, value: planAnnual.value },
      ],
      content_ids: [planAnnual.items[0].item_id],
      content_name: planAnnual.items[0].item_name,
      content_type: 'product',
    });
  });

  // Event on Top right “Buy” button clicked
  document.querySelector('.section-hero-plus a.btn-buy').addEventListener('click', function (event) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'sentry_buy',
      ecommerce: planAnnual,
    });

    if(typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_buy', {
      currency: 'USD',
      value: planAnnual.value,
      contents: [
        { id: planAnnual.items[0].item_id, quantity: 1, valueAnnual: planAnnual.valueAnnual, value: planAnnual.value },
      ],
      content_ids: [planAnnual.items[0].item_id],
      content_name: planAnnual.items[0].item_name,
      content_type: 'product',
    });
  });

  // Event on Banner “ORDER NOW” button clicked
  document
    .querySelector('.section-hero-plus .section-hero-content a.btn-primary')
    .addEventListener('click', function (event) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'sentry_order_now',
        ecommerce: planAnnual,
      });

      if(typeof fbq === 'undefined') return;

      fbq('trackCustom', 'sentry_order_now', {
        currency: 'USD',
        value: planAnnual.value,
        contents: [
          {
            id: planAnnual.items[0].item_id,
            quantity: 1,
            valueAnnual: planAnnual.valueAnnual,
            value: planAnnual.value,
          },
        ],
        content_ids: [planAnnual.items[0].item_id],
        content_name: planAnnual.items[0].item_name,
        content_type: 'product',
      });
    });

  // Event on Banner “WATCH VIDEO” button clicked
  document
    .querySelector('.section-hero-plus .section-hero-content a.btn-watch')
    ?.addEventListener('click', function (event) {
      dataLayer.push({
        event: 'sentry_video_watch',
      });

      if(typeof fbq === 'undefined') return;

      fbq('trackCustom', 'sentry_video_watch');
    });

  // Event on airID section “Learn More” button clicked
  document.querySelector('.section-card-modal [data-open="modal"]').addEventListener('click', function (event) {
    dataLayer.push({
      event: 'sentry_airid_learn',
    });

    if(typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_airid_learn');
  });

  // Event on Case study section clicked
  document.querySelector('.section-card-link .section-card').addEventListener('click', function (event) {
    dataLayer.push({
      event: 'sentry_case_learn',
    });

    if(typeof fbq === 'undefined') return;

    fbq('trackCustom', 'sentry_case_learn');
  });

  // Event on Annual plan selected
  document
    .querySelector('.section-sentry-plan .section-price:nth-child(1) .price-button a')
    .addEventListener('click', function (event) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'sentry_select_annual',
        ecommerce: planAnnual,
      });

      if(typeof fbq === 'undefined') return;

      fbq('trackCustom', 'sentry_select_annual', {
        currency: 'USD',
        value: planAnnual.value,
        contents: [
          {
            id: planAnnual.items[0].item_id,
            quantity: 1,
            valueAnnual: planAnnual.valueAnnual,
            value: planAnnual.value,
          },
        ],
        content_ids: [planAnnual.items[0].item_id],
        content_name: planAnnual.items[0].item_name,
        content_type: 'product',
      });
    });

  // Event on Monthly plan selected
  document
    .querySelector('.section-sentry-plan .section-price:nth-child(2) .price-button a')
    .addEventListener('click', function (event) {
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'sentry_select_monthly',
        ecommerce: planMonthly,
      });

      if(typeof fbq === 'undefined') return;

      fbq('trackCustom', 'sentry_select_monthly', {
        currency: 'USD',
        value: planMonthly.value,
        contents: [
          {
            id: planMonthly.items[0].item_id,
            quantity: 1,
            valueAnnual: planMonthly.valueAnnual,
            value: planMonthly.value,
          },
        ],
        content_ids: [planMonthly.items[0].item_id],
        content_name: planMonthly.items[0].item_name,
        content_type: 'product',
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-tabs-plus"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-tabs-plus').on('click', '.section-tab', function () {
      const index = $(this).index();
      $(this).addClass('active').siblings().removeClass('active');
      const thisTab = $('.section-tabs-plus .section-tab-content').eq(index);
      thisTab.addClass('active').siblings().removeClass('active');
      $('.section-tabs-plus .section-tabs-content').height(thisTab.height());
    });

    $('.section-tabs-plus .section-tab').first().click();

    $(window).on('resize', function () {
      $('.section-tabs-plus .section-tab.active').click();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-tabs-savings"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-tabs-savings').on('click', '.section-tab', function () {
      const index = $(this).index();
      $(this).addClass('active').siblings().removeClass('active');
      const thisTab = $('.section-tabs-savings .section-tab-content').eq(index);
      thisTab.addClass('active').siblings().removeClass('active');
      $('.section-tabs-savings .section-tabs-content').height(thisTab.height());
    });

    $('.section-tabs-savings .section-tab').first().click();

    $(window).on('resize', function () {
      $('.section-tabs-savings .section-tab.active').click();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-tabs"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('.section-faq-tabs').on('click', '.section-tab', function () {
      const index = $(this).index();
      $(this).addClass('active').siblings().removeClass('active');
      const thisTab = $('.section-faq-tabs .section-tab-content').eq(index);
      thisTab.addClass('active').siblings().removeClass('active');
      $('.section-faq-tabs .section-tabs-content').height(thisTab.height());
    });

    $('.section-faq-tabs .section-tab').first().click();

    $(window).on('resize', function () {
      $('.section-faq-tabs .section-tab.active').click();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-accordion-full"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function () {
    $('body').on('click','.section-card',function (event) {
      $(this).addClass('card-active');
      $(this).siblings('.card-active').removeClass('card-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-accordion"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('body').on('click','.section-card',function (event) {
      
      $(this).addClass('card-active');
      $(this).siblings('.card-active').removeClass('card-active');
      
      const $imageCard = $(this).closest('.section-row').find('.card-image').eq($(this).index());
      $imageCard.addClass('image-active');
      $imageCard.siblings('.image-active').removeClass('image-active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
